module.exports = __webpack_public_path__ + "media/images/ui__arrowLeftInactive--dark-89fe1cf6be03145fbb1379d6cf685e42.png";